import styled from "styled-components";

export const ProjectCardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));

  gap: 12px;

  @media all and (width > ${({ theme }) => `${theme.mediaQuery.LARGE}px`}) {
    grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));
  }

  @media all and (width >= ${({ theme }) =>
      `${theme.mediaQuery.MEDIUM}px`}) and (width <= ${({ theme }) =>
      `${theme.mediaQuery.LARGE}px`}) {
    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  }

  @media all and (width < ${({ theme }) => `${theme.mediaQuery.MEDIUM}px`}) {
    display: flex;
    flex-direction: column;
  }
`;
